/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-get */
import Helper from '@ember/component/helper';
import { isArray } from '@ember/array';
import { service } from '@ember/service';
import { capitalize as capitalizeString } from '@ember/string';
import { effortLabelFor } from '@linc-technologies/linced-common/utils/effort-labels';

export default class EffortJudgementLabel extends Helper {
  @service
  session;

  compute(params, options) {
    if (!isArray(params) || params.length < 1) {
      return '';
    }

    let jurisdiction = this.get('session.school.jurisdiction');
    return getEffortJudgementLabel(params[0], options, jurisdiction);
  }
}

export function getEffortJudgementLabel(
  judgement,
  { capitalize },
  jurisdiction,
) {
  let label = effortLabelFor(judgement, jurisdiction) || '';

  if (capitalize) {
    label = capitalizeString(label);
  }

  return label;
}
